import DownloadIcon from '@/components/_common/DownloadIcon';
import {
  useBankSlipConsultPdf,
  useBankSlipRequestPdf,
} from '@/core/domain/financial/Boletos/Boletos.hooks';
import { useReportActions } from '@/hooks/useReportActions';
import { Button, notification, Spin } from 'antd';
import { useState } from 'react';

interface Props {
  bankSlip: {
    id: number;
    printProtocol?: string;
    ourNumber?: string;
  };
  show?: boolean;
  type?: 'button' | 'icon';
}

export default function BankSlipDownload({ type, ...props }: Props) {
  const hasPrintProtocol = !!props.bankSlip.printProtocol;
  const label = hasPrintProtocol ? 'Baixar PDF' : 'Consultar PDF';

  const bankSlipConsultPdf = useBankSlipConsultPdf();
  const bankSlipRequestPdf = useBankSlipRequestPdf();
  const [loading, setLoading] = useState(false);

  const { handlePdf } = useReportActions({
    fileName: `boleto-${props.bankSlip.ourNumber}`,
    generate: async () =>
      await bankSlipConsultPdf.mutateAsync(props.bankSlip.id),
  });

  const handleGenerate = async () => {
    const notifKey = `boleto-${props.bankSlip.id}`;

    try {
      setLoading(true);

      if (!hasPrintProtocol) {
        notification.info({
          key: notifKey,
          message: 'Gerando boleto...',
          description: 'Aguarde alguns instantes enquanto criamos seu boleto.',
          icon: <Spin size="small" />,
        });

        const result = await bankSlipRequestPdf.mutateAsync(props.bankSlip.id);

        notification.close(notifKey);

        notification.info({
          message: 'Boleto atualizado!',
          description:
            result?.situation ||
            'O boleto foi gerado ou atualizado. Tente novamente para baixá-lo.',
          duration: 4,
        });

        return await handlePdf();
      }

      return await handlePdf();
    } catch {
      notification.error({
        message: 'Falha ao gerar boleto',
        description:
          'Ocorreu um erro ao tentar gerar o boleto. Tente novamente.',
      });
    } finally {
      setLoading(false);
    }
  };

  if (!props.show) return null;

  if (type === 'button') {
    return (
      <Button type="primary" onClick={handleGenerate} loading={loading} block>
        {label}
      </Button>
    );
  }

  return (
    <DownloadIcon
      iconProps={{ onClick: handleGenerate }}
      disabled={loading}
      content={label}
    />
  );
}
